module.exports = __webpack_public_path__ + "img/icon-shop.25dd575f.png";